<template>
  <TransitionGroup
    enter-from-class="opacity-0 scale-105"
    enter-active-class="transition-all duration-500 w-full h-screen overflow-hidden ease-in-out"
    leave-to-class="opacity-0"
    @before-enter="addOverflow"
    @after-enter="removeOverflow">
    <RouterView v-if="isLoggingIn" />
    <NtConfirm
      v-else-if="authUser && $cannot('access admin hub')"
      level="danger"
      icon="fa-exclamation-triangle"
      heading="Forbidden"
      confirm-label="Log Out"
      @confirmed="logOut"
      no-dismiss
      hide-cancel
      auto-open>
      You do not have access to the admin hub.
    </NtConfirm>
    <div v-else-if="isInitialized">
      <NtNavigationSidebarContainer ref="sidebar" />
      <div class="2xl:pl-72">
        <NtHeaderBar @open-sidebar="$refs.sidebar.open()" />
        <main class="py-10">
          <div class="px-4 sm:px-6 2xl:px-8">
            <div class="container @container mx-auto">
              <NtPageHeader
                v-if="httpError?.code > 400"
                :heading="httpError?.code === 9999 ? 'Something Went Wrong..' : `Error ${httpError.code}`"
                :introduction="httpError.message" />
              <NtPageHeader
                v-else-if="
                  authUser &&
                  $route.matched[0].meta.permission &&
                  !authUser.admin_access_permissions_list.includes($route.matched[0].meta.permission)
                "
                heading="Error 403"
                :introduction="`You do not have permission to ${$route.matched[0].meta.permission}.`" />
              <RouterView v-else />

              <NtConfirm
                v-if="httpError?.code === 400"
                level="danger"
                icon="fa-exclamation-triangle"
                heading="Error"
                confirm-label="OK"
                hide-cancel
                auto-open
                @confirmed="clearHttpError">
                {{ httpError.message }}
              </NtConfirm>
            </div>
          </div>
        </main>
      </div>
      <NtUploadProgress />
      <NtNotificationToast />
    </div>

    <div v-else class="flex flex-col h-screen items-center justify-center p-6">
      <NtLoader class="mb-3" loading />
    </div>
  </TransitionGroup>
</template>

<script>
import { RouterView } from 'vue-router'
import { mapActions, mapState } from 'pinia'
import { useAuthStore } from './stores/auth'
import { useErrorStore } from './stores/error'
import NtLoader from './components/general/NtLoader.vue'
import NtNavigationSidebarContainer from './components/navigation/NtNavigationSidebarContainer.vue'
import { useSystemStore } from './stores/system'
import NtHeaderBar from './components/navigation/NtHeaderBar.vue'
import NtPageHeader from './components/general/NtPageHeader.vue'
import NtUploadProgress from './components/general/NtUploadProgress.vue'
import NtConfirm from './components/general/NtConfirm.vue'
import NtNotificationToast from './components/navigation/NtNotificationToast.vue'
import PageView from './views/PageView.vue'

export default {
  components: {
    RouterView,
    NtLoader,
    NtNavigationSidebarContainer,
    NtHeaderBar,
    NtPageHeader,
    NtUploadProgress,
    NtConfirm,
    NtNotificationToast
  },
  computed: {
    ...mapState(useSystemStore, ['systemInitialized']),
    ...mapState(useAuthStore, ['authInitialized', 'authUser']),
    ...mapState(useErrorStore, ['httpError']),
    isLoggingIn() {
      return this.$route.path === '/oauth/login'
    },
    isInitialized() {
      return this.systemInitialized && this.authInitialized
    }
  },
  async created() {
    await this.$router.isReady()
    this.rebuildRoutes(this.$router, PageView)
    // try {
    if (!this.isLoggingIn) {
      await this.initAuth()
    }
    // } catch (e) {
    //   console.error('Failed to initialize admin hub.', e.message)
    // }
  },
  methods: {
    ...mapActions(useAuthStore, ['initAuth', 'logOut']),
    ...mapActions(useSystemStore, ['initSystem', 'rebuildRoutes']),
    ...mapActions(useErrorStore, ['clearHttpError']),
    addOverflow() {
      document.body.classList.add('overflow-hidden')
    },
    removeOverflow() {
      document.body.classList.remove('overflow-hidden')
    }
  }
}
</script>
